import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';

import VueYoutube from 'vue-youtube';
Vue.use(VueYoutube);


Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/intel',
    name: 'Intel',
    component: () => import('../views/Intel.vue'),
  },
  {
    path: '/googlevoicesearch',
    name: 'GoogleVoiceSearch',
    component: () => import('../views/GoogleVoiceSearch.vue'),
  },
  {
    path: '/opportunities',
    name: 'Opportunities',
    component: () => import('../views/Opportunities.vue'),
  },
  {
    path: '/creator',
    name: 'Creator',
    component: () => import('../views/Creator.vue'),
  },
  {
    path: '/designer',
    name: 'Designer',
    component: () => import('../views/Designer.vue'),
  },
  {
    path:'/program',
    name:'Program',
    component: () => import('../views/Program.vue'),
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: () => import('../views/Analytics.vue'),
  },
  {
    path: '/manager',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
  },
  {
    path: '/notes',
    name: 'Notes',
    component: () => import('../components/Notes.vue'),
  },
  {
    path: '/leads',
    name: 'Leads',
    component: () => import('../views/Leads.vue'),
  },
  {
    path: '/userdashboard',
    name: 'UserDashboard',
    component: () => import('../views/UserDashboard.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: () => import('../views/Contacts.vue'),
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import('../views/Clients.vue'),
  },
  {
    path: '/buybacks',
    name: 'Buybacks',
    component: () => import('../views/Buybacks.vue'),
  },
  {
    path: '/accounts',
    name: 'Accounts',
    component: () => import('../views/Accounts.vue'),
  },
  {
    path: '/dailybriefing',
    name: 'DailyBriefing',
    component: () => import('../views/DailyBriefing.vue'),
  },
  {
    path: '/clientemail',
    name: 'ClientEmail',
    component: () => import('../views/ClientEmail.vue'),
  },
  {
    path: '/productmatrix',
    name: 'ProductMatrix',
    component: () => import('../views/ProductMatrix.vue'),
  },
  {
    path: '/directory',
    name: 'Directory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Directory.vue'),
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
  },
  {
    path: '/activeusers',
    name: 'ActiveUsers',
    component: () => import('../views/ActiveUsers.vue'),
  },
  {
    path: '/pendingapproval',
    name: 'PendingApproval',
    component: () => import('../views/PendingApproval.vue'),
  },
  {
    path: '/usersettings',
    name: 'UserSettings',
    component: () => import('../views/UserSettings.vue'),
  },
  {
    path: '/chat',
    name: 'Chat',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Chat.vue'),
  },
  {
    path: '/calendar',
    name: 'Calendar',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/Calendar.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue'),
  },
  {
    path: '/interface',
    name: 'Interface',
    component: () => import(/* webpackChunkName: "about" */ '../views/Interface.vue'),
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import(/* webpackChunkName: "about" */ '../views/Welcome.vue'),
  },
  {
    path: '/missioncontrol',
    name: 'MissionControl',
    component: () => import(/* webpackChunkName: "about" */ '../views/MissionControl.vue'),
  },
  {
    path: '/experience',
    name: 'Experience',
    component: () => import(/* webpackChunkName: "about" */ '../views/Experience.vue'),
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import(/* webpackChunkName: "about" */ '../views/Map.vue'),
  },
  {
    path: '/earth',
    name: 'Earth',
    component: () => import(/* webpackChunkName: "about" */ '../views/Earth.vue'),
  },
  {
    path: '/fulfillments',
    name: 'Fulfillments',

    component: () => import(/* webpackChunkName: "about" */ '../views/Fulfillments.vue'),
  },
  {
    path: '/tasks',
    name: 'Tasks',

    component: () => import(/* webpackChunkName: "about" */ '../views/Tasks.vue'),
  },
  {
    path: '/repairs',
    name: 'Repairs',

    component: () => import(/* webpackChunkName: "about" */ '../views/Repairs.vue'),
  },
  {
    path: '/que',
    name: 'Que',
    component: () => import(/* webpackChunkName: "about" */ '../views/Que.vue'),
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import('../views/Invoices.vue'),
  },
  {
    path: '/proposals',
    name: 'Proposals',
    component: () => import('../views/Proposals.vue'),
  },
  // {
  //   path: '/proposalsnew',
  //   name: 'ProposalsNew',
  //   component: () => import('../views/ProposalsNew.vue'),
  // },
  {
    path: '/vendorLeads',
    name: 'VendorLeads',
    component: () => import('../views/VendorLeads.vue'),
  },
  {
    path: '/sales',
    name: 'Sales',
    component: () => import('../views/Sales.vue'),
  },
  {
    path: '/vendors',
    name: 'Vendors',
    component: () => import('../views/Vendors.vue'),
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: () => import('../views/Inventory.vue'),
  },
  {
    path: '/inventorylist',
    name: 'InventoryList',
    component: () => import('../views/InventoryList.vue'),
  },
  {
    path: '/inventorylist/:id',
    name: 'InventoryList',
    component: () => import('../views/InventoryList.vue'),
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('../views/Settings.vue'),
  },
  {
    path: '/videocall',
    name: 'VideoCall',
    component: () => import('../views/VideoChat.vue'),
  },
  {
    path: '/video',
    name: 'Video',
    component: () => import('../components/FaceDetection.vue'),
  },
  {
    path: '/email',
    name: 'email',
    component: () => import(/* webpackChunkName: "about" */ '../views/Email.vue'),
  },

  {
    name: 'Email',
    path: '/email/inbox',
    component: () => import('../views/Email.vue'),
    children: [
      {
        path: '/email/:mailType',
        name: 'MailIndex',
        component: () => import('@/views/apps/email/EmailList.vue'),
      },
      {
        path: '/email/:mailType/0/:uuid',
        name: 'MailDetail1',
        component: () => import('@/views/apps/email/EmailDetail.vue'),
      },
      {
        path: '/email/0/:mailTag',
        name: 'MailTag',
        component: () => import('@/views/apps/email/EmailList.vue'),
      },
      {
        path: '/email/0/:mailTag/0/:uuid',
        name: 'MailDetail',
        component: () => import('@/views/apps/email/EmailDetail.vue'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;

